import React from 'react'
import Search from '../Search'
import FloatingAddButton from '../../utils/FloatingAddButton';
import UsersTable from './UsersTable'
import { useState } from 'react';

const UsersList = () => {

  const [searchKey, setSearchKey] = useState('')

  const handleSearch = (searchText) => {
    setSearchKey(searchText);
  };

  return (
    <>
      <Search title={"Pesquise por nome ou apelido do Usuário"} onSearch={handleSearch}/>
      <UsersTable searchKey={searchKey}/>
      <FloatingAddButton toolTitle={"Adicionar novo usuário"} link={"new"}/>
    </>
  )
}

export default UsersList